import { inject, Injectable } from '@angular/core';
import type { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable } from 'rxjs';

import { TranslationStrategyFactory } from '@customer-portal/shared/services/translation';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private strategy = inject(TranslationStrategyFactory).getStrategy();

  getTranslation(lang: string): Observable<Translation> {
    return this.strategy.loadGlobal(lang);
  }
}
